import PropTypes from "prop-types";
import clsx from "classnames";
import { Button, Col, Container, Dropdown, Row, Stack } from "react-bootstrap";
import { BlogFeedCard } from "@/ui";
import { getRoute } from "@/getters/getRoute";
import classes from "./styles.module.scss";
import { useLoadMore } from "@/hooks/useLoadMore";
import { useOptionFilter } from "@/hooks/useOptionFilter";
import { getArticleCardImage } from "@/getters/getArticleCardImage";

export default function CaseStudiesFeed({
  className,
  items: _rawItems,
  articleType,
}) {
  const [items, setItems, loadMore, page, pages] = useLoadMore(_rawItems);
  const [sectors, sectorFilter, setSectorFilter] = useOptionFilter(_rawItems, "sector", setItems);
  const [services, serviceFilter, setServiceFilter] = useOptionFilter(_rawItems, "service", setItems);
  const [benefit, benefitFilter, setBenefitFilter] = useOptionFilter(_rawItems, "benefit", setItems);

  return (
    <div className={clsx(className, classes.feed)}>
      <Container className="mw-xxl">
        <Stack className={clsx(classes.feed__filters, "p-4 mb-4")}>
          <Row>
            <Col xs={12} md={4}>
              <Dropdown>
                <Dropdown.Header>By Sector</Dropdown.Header>
                <Dropdown.Toggle className="mt-3" variant="white">
                  {sectorFilter ?? "Select Sector"}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => setSectorFilter(null)}>Select Sector</Dropdown.Item>
                  {sectors.map((c, k) => (
                    <Dropdown.Item key={k} onClick={() => setSectorFilter(c)}>
                      {c}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </Col>
            <Col xs={12} md={4}>
              <Dropdown>
                <Dropdown.Header className="mb-3">By Service</Dropdown.Header>
                <Dropdown.Toggle variant="white">{serviceFilter ?? "Select Service"}</Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => setServiceFilter(null)}>Select Service</Dropdown.Item>
                  {services.map((c, k) => (
                    <Dropdown.Item key={k} onClick={() => setServiceFilter(c)}>
                      {c}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </Col>
            <Col xs={12} md={4}>
              <Dropdown>
                <Dropdown.Header className="mb-3">By Benefit</Dropdown.Header>
                <Dropdown.Toggle variant="white">{benefitFilter ?? "Select Benefit"}</Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => setBenefitFilter(null)}>Select Benefit</Dropdown.Item>
                  {benefit.map((c, k) => (
                    <Dropdown.Item key={k} onClick={() => setBenefitFilter(c)}>
                      {c}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </Col>
          </Row>
        </Stack>
        <Row>
          {items.map((item, k) => {
            const { title, image, publish_date, url_slug } = item;
            return (
              <Col key={k} xs={12} md={4} className="mb-4">
                <BlogFeedCard
                  className="h-100"
                  title={title}
                  img={getArticleCardImage(item, articleType)}
                  published_at={publish_date}
                  href={getRoute(articleType, { url_slug })}
                />
              </Col>
            );
          })}
        </Row>
        {page < pages && (
          <Stack className={clsx(classes.feed__footer)}>
            <Button variant="secondary" onClick={loadMore}>
              Load More
            </Button>
          </Stack>
        )}
      </Container>
    </div>
  );
}

CaseStudiesFeed.defaultProps = {
  className: "py-5",
  articleType: "caseStudy",
};

CaseStudiesFeed.propTypes = {
  className: PropTypes.string,
};
